import type { ContainerTypeInput } from '@chukua/common';
import { api } from '../../../../shared/shared.api';
import { listContainerTypes, type ContainerType } from '../../reference-data.api';
import type { CatalogueApi } from '../../hooks/use-catalogue';

/** Admin-managed (`configuration.manage`, gitaumoses4/chukua#355); the list call and row type are shared with the pickers, so they stay in `reference-data.api.ts`. */
export const containerTypesApi: CatalogueApi<ContainerType, ContainerTypeInput> = {
  list: listContainerTypes,
  create: (input) => api<ContainerType>('/container-types', { method: 'POST', body: JSON.stringify(input) }),
  update: (id, input) => api<ContainerType>(`/container-types/${id}`, { method: 'PATCH', body: JSON.stringify(input) }),
  deactivate: async (id) => {
    await api<void>(`/container-types/${id}/deactivate`, { method: 'POST' });
  },
  reactivate: async (id) => {
    await api<void>(`/container-types/${id}/reactivate`, { method: 'POST' });
  },
};
